import { useRouter } from 'next/router';
import { useEffect } from 'react';
import editorEventsBus from '../editorEventsBus';
import { getWebsiteTimezoneConfig } from '@/service';

export default function MemberGloDataA() {
    const { locale = 'us' } = useRouter();
    const replaceTimeFormat = (timeStr: string) => {
        if (!timeStr) return '';
        return timeStr.replaceAll('-', '/');
    };
    const getSeasonInfo = async () => {
        const res = await getWebsiteTimezoneConfig(locale, {});

        if (res?.code === '0' && res?.data) {
            const dataA = res.data || [];
            if (!dataA.length) {
                return;
            }
            const timezoneList =
                res.data.map((item: any) => {
                    const summerTimestamp = item.switchSummerTime ? new Date(`${replaceTimeFormat(item.switchSummerTime)} GMT+8`).getTime() : 0;
                    const winterTimestamp = item.switchWinterTime ? new Date(`${replaceTimeFormat(item.switchWinterTime)} GMT+8`).getTime() : 0;
                    return {
                        summerTimezone: item.summerTimezone,
                        winterTimezone: item.winterTimezone,
                        commonTimezone: item.commonTimezone,
                        switchSummerTimestamp: summerTimestamp,
                        switchWinterTimestamp: winterTimestamp,
                        enable: item.enable,
                        id: item.id,
                        needSwitchFlag: item.needSwitchFlag,
                        site: item.site,
                        year: item.year,
                    };
                }) || [];

            editorEventsBus.emit('member-global-a', timezoneList);
            //setSeasonInfo(timezoneList);
        }
    };

    useEffect(() => {
        getSeasonInfo();
    }, []);
    return null;
}
